export default __webpack_public_path__ + "static/media/car-gray.cfd754c6.svg";